import { Box } from "@mui/material";
import { FormikValues, useFormikContext } from "formik";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

import AdmissionStepOne from "../admissionSteps/AdmissionStepOne";
import AdmissionStepTwo from "../admissionSteps/AdmissionStepTwo";
import SupportiveDocuments from "../admissionSteps/AdmissionStepFour";
import AdmissionDetails from "../admissionSteps/AdmissionStepZero";
// import AdmissionStepThree from "../admissionSteps/AdmissionStepThree";

import patientService from "../../../../../services/patient";

import { useAppDispatch } from "../../../../../redux/store";
import { setLoadingAction } from "../../../../../redux/utils/actions";
import { logger } from "../../../../../utils/logger";

const AddPatientForm = ({ steps }: { steps: number }) => {
  const { setValues } = useFormikContext<FormikValues>();
  const dispatch = useAppDispatch();

  const { id } = useParams();

  useEffect(() => {
    const getData = async () => {
      try {
        if (id) {
          dispatch(setLoadingAction(true));
          const res = await patientService.getById(id);
          const { data } = res?.data;
          dispatch(setLoadingAction(false));
          const [year, month, day] = res?.data?.data?.age?.split("-");
          const formValues = {
            ...data,
            year,
            month,
            day,
            isLowerIncomeBeneficiary: `${data.isLowerIncomeBeneficiary}`,
            incomeCertificate:
              data?.incomeCertificate !== ""
                ? [
                    {
                      label: "Income Certificate",
                      path: data.incomeCertificate,
                    },
                  ]
                : "",
          };
          setValues(formValues);
        }
      } catch (error: any) {
        dispatch(setLoadingAction(false));
        logger.error(error);
      }
    };
    if (id) {
      getData();
    }
  }, [dispatch, id, setValues]);

  return (
    <div>
      <Box sx={{ color: "#242424" }}>
        {steps === 0 && <AdmissionDetails />}
        {steps === 1 && <AdmissionStepOne />}
        {steps === 2 && <SupportiveDocuments />}
      </Box>
    </div>
  );
};

export default AddPatientForm;
